import api from './axios'

/**
 * Departments API
 */
export const departmentsApi = {
    /**
     * Get all departments (optionally filtered by form access)
     */
    getAll: async (formId = null) => {
        const params = formId ? `?form_id=${formId}` : ''
        const response = await api.get(`/departments${params}`)
        return response
    },

    /**
     * Get single department
     */
    getById: async (id) => {
        const response = await api.get(`/departments/${id}`)
        return response
    },

    /**
     * Create department
     */
    create: async (data) => {
        const response = await api.post('/departments', data)
        return response
    },

    /**
     * Update department
     */
    update: async (id, data) => {
        const response = await api.put(`/departments/${id}`, data)
        return response
    },

    /**
     * Delete department
     */
    delete: async (id) => {
        const response = await api.delete(`/departments/${id}`)
        return response
    },

    /**
     * Navigate submission to department
     */
    navigate: async (submissionId, departmentId, notes = null) => {
        const response = await api.post('/departments/navigate', {
            submission_id: submissionId,
            department_id: departmentId,
            notes,
        })
        return response
    },

    /**
     * Add department comment
     */
    addComment: async (submissionId, comment) => {
        const response = await api.post('/departments/comment', {
            submission_id: submissionId,
            comment,
        })
        return response
    },

    /**
     * Get comments for submission
     */
    getComments: async (submissionId) => {
        const response = await api.get(`/departments/comments/${submissionId}`)
        return response
    },

    /**
     * Get navigation history
     */
    getNavigations: async (submissionId) => {
        const response = await api.get(`/departments/navigations/${submissionId}`)
        return response
    },

    /**
     * Get department submissions
     */
    getSubmissions: async (filters = {}) => {
        const params = new URLSearchParams()

        if (filters.status) params.append('status', filters.status)
        if (filters.archived !== undefined) params.append('archived', filters.archived)
        if (filters.page) params.append('page', filters.page)
        if (filters.perPage) params.append('per_page', filters.perPage)

        const response = await api.get(`/departments/submissions?${params.toString()}`)
        return response
    },

    /**
     * Add user to department
     */
    addUser: async (departmentId, userData) => {
        const response = await api.post('/department-users', {
            department_id: departmentId,
            ...userData,
        })
        return response
    },

    /**
     * Get users for a department
     */
    getUsers: async (departmentId) => {
        const response = await api.get(`/department-users/department/${departmentId}`)
        return response
    },

    /**
     * Update department user
     */
    updateUser: async (userId, userData) => {
        const response = await api.put(`/department-users/${userId}`, userData)
        return response
    },

    /**
     * Delete department user
     */
    deleteUser: async (userId) => {
        const response = await api.delete(`/department-users/${userId}`)
        return response
    },

    /**
     * Set/unset user as department leader (Admin only)
     */
    setLeader: async (userId, isLeader) => {
        const response = await api.put(`/departments/users/${userId}/leader`, {
            is_leader: isLeader
        })
        return response
    },
}

export default departmentsApi
